import { PerguntaTipo } from "../entities/QuestionnaireEntity";

export type Unpacked<T> = T extends (infer U)[] ? U : T;

export const FormTipos = [
	{ label: "Texto", value: PerguntaTipo.text },
	{ label: "Texto múltiplas linhas", value: PerguntaTipo.textarea },
	{ label: "Número", value: PerguntaTipo.number },
	{ label: "Seleção única", value: PerguntaTipo.radio },
	{ label: "Seleção múltipla", value: PerguntaTipo.checkbox },
	{ label: "Seleção", value: PerguntaTipo.select },
	{ label: "Arquivo", value: PerguntaTipo.file },
	{ label: "Imagem", value: PerguntaTipo.image },
	{ label: "Data", value: PerguntaTipo.date },
	{ label: "Objetiva", value: PerguntaTipo.objective },
	{ label: "Geolocalização", value: PerguntaTipo.geo },
	{ label: "Parâmetro", value: PerguntaTipo.parametro },
];

export const SkeletonCount = 10;
export const PageSize = 10;
export const Location = { lat: -30.033056, lng: -51.23 };
export const DateFormat = "DD/MMM/YYYY";
export const DateTimeFormat = "DD/MMM/YYYY HH:mm:ss";
export const TokenRefreshInterval = 25; // minutos
export const DefaultPosition = { lat: -30.033056, lng: -51.23 };

export enum ModuleEntity {
	acessos = 1001,
	configuracoes = 1002,
	configuracoesAvaliacoes = 1003,
	configuracoesParametros = 1004,
	configuracoesDominios = 1005,
	avaliacoes = 1006,
}

export const NavigationEntity: { [key: number]: string } = {
	1001: "/usuarios",
	1002: "/avaliacoes",
	1003: "/configuracoesAvaliacoes",
};

export enum ModulePermissionEntity {
	visualizar = 9991,
	editar = 9992,
	teste = 9999,
}

export type EscalaType = {
	[key: string]: {
		titulo: string;
		descricao: string;
		cor: string;
		faixa: number[];
	};
};

export const EscalaRisco: EscalaType = {
	"1": {
		titulo: "Sem Risco",
		descricao: "Anomalias inexistentes ou estritamente superficiais; sem impacto em capacidade resistente/estabilidade/funcionalidade estrutural.",
		cor: "#34cc33",
		faixa: [0, 20],
	},
	"2": {
		titulo: "Danos Leves",
		descricao:
			"Danos localizados de baixa relevância em elementos estruturais (ex.: fissuras não ativas e finas, proteção superficial deteriorada, corrosão incipiente sem perda mensurável de seção, flechas dentro de limites normativos); funcionamento preservado.",
		cor: "#339965",
		faixa: [20, 40],
	},
	"3": {
		titulo: "Danos Moderados",
		descricao:
			"Danos com indicativos de evolução (ex.: fissuras ativas moderadas, início de perda de seção por corrosão, flechas/rotações mensuráveis próximas aos limites, assentos diferenciais moderados, scour inicial); redução parcial da capacidade funcional, reparação viável com técnicas usuais e controle.",
		cor: "#ffff00",
		faixa: [40, 60],
	},
	"4": {
		titulo: "Danos Significativos",
		descricao:
			"Danos relevantes que comprometem a funcionalidade e/ou a estabilidade local (ex.: perda de seção relevante, destacamentos de concreto com exposição de armaduras, degradação importante de aparelhos de apoio, fissuração ampla/ativa em elemento crítico, escoramento pontual recomendável, restrição operacional localizada).",
		cor: "#ffbf00",
		faixa: [60, 80],
	},
	"5": {
		titulo: "Comprometimento Grave",
		descricao:
			"Instabilidade ou rupturas locais, deslocamentos/assentamentos excessivos, falhas em cabos/pendurais/aparelhos de apoio, scour severo, risco à segurança de usuários/operadores; requer reforço/escoramento imediato e/ou interdição (parcial ou total).",
		cor: "#c00201",
		faixa: [80, 101],
	},
};

export const EscalaVunerabilidade: EscalaType = {
	"1": {
		titulo: "Funcionalidade Preservada",
		descricao: "Sistemas íntegros; apenas manutenção rotineira. Operação sem restrições.",
		cor: "#34cc33",
		faixa: [0, 20],
	},
	"2": {
		titulo: "Leves perdas na Funcionalidade",
		descricao:
			"Pequenos danos/localizados (ex.: desgaste superficial do revestimento, drenagem com redução pontual, emperramentos ocasionais de juntas, infiltrações leves, iluminação com falhas pontuais). Uso preservado, correções simples.",
		cor: "#339965",
		faixa: [20, 40],
	},
	"3": {
		titulo: "Funcionalidade Moderadamente Afetada",
		descricao:
			"Falhas recorrentes com impacto perceptível (ex.: descolamentos/ondulações de camada de rolamento, drenagem ineficiente com poças, juntas com batentes, falhas em componentes essenciais de instalações, estanqueidade deficiente em áreas significativas). Redução parcial da funcionalidade; requer manutenção corretiva setorial.",
		cor: "#ffff00",
		faixa: [40, 60],
	},
	"4": {
		titulo: "Funcionalidade Significativamente Comprometida",
		descricao:
			"Falhas relevantes em múltiplos sistemas (ex.: drenagem crítica com risco de aquaplanagem, barreiras comprometidas, iluminação/sinalização insuficientes, ventilação inadequada em túnel), restrições operacionais (redução de faixa/velocidade ou interdição setorial) e intervenções coordenadas.",
		cor: "#ffbf00",
		faixa: [60, 80],
	},
	"5": {
		titulo: "Funcionalidade Severamente Comprometida",
		descricao:
			"Inoperância ou risco à segurança/saúde (ex.: falhas generalizadas em elétrica/ventilação de túnel, infiltrações intensas com risco de queda de materiais, juntas colapsadas, barreiras ineficazes). Uso inviável até correção.",
		cor: "#c00201",
		faixa: [80, 101],
	},
};

export const EscalaComprometimento: EscalaType = {
	"1": {
		titulo: "Comprometimento Muito Baixo",
		descricao: "Risco estrutural baixo, vulnerabilidade funcional baixa e boa manutenção; operação normal; custos de intervenção baixos com alto benefício.",
		cor: "#34cc33",
		faixa: [0, 20],
	},
	"2": {
		titulo: "Comprometimento Baixo",
		descricao: "Níveis moderados e pontuais de risco/vulnerabilidade; pequenas restrições operacionais; custos moderados com benefícios claros após correções.",
		cor: "#339965",
		faixa: [20, 40],
	},
	"3": {
		titulo: "Comprometimento Moderado",
		descricao: "Comprometimento parcial de desempenho/uso; requer plano de intervenção com custos consideráveis, justificáveis pelo ganho de desempenho e segurança.",
		cor: "#ffff00",
		faixa: [40, 60],
	},
	"4": {
		titulo: "Comprometimento Alto",
		descricao: "Risco estrutural e/ou vulnerabilidade funcional elevados, com restrições operacionais (redução/interdição parcial); custos altos e necessidade de obras mais abrangentes.",
		cor: "#ffbf00",
		faixa: [60, 80],
	},
	"5": {
		titulo: "Comprometimento Muito Alto",
		descricao:
			"Condição crítica (risco à segurança e/ou inoperabilidade), interdição parcial/total até correção; custos muito elevados e possível necessidade de escoramento/reforços ou substituição.",
		cor: "#c00201",
		faixa: [80, 101],
	},
};
